// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"SubmitButton_buttonsContainer__jOVhD"};